   export function formateManifestFromBackend(manifest: string): string {
  let formatted = '';
  const reg = /(>)(<)(\/*)/g;
  manifest = manifest.replace(reg, '$1\r\n$2$3');
  let pad = 0;
  manifest.split('\r\n').forEach((node) => {
    let indent = 0;

    switch (true) {
      case /.+<\/\w[^>]*>$/.test(node):
        indent = 0;
        break;
      case /^<\/\w/.test(node):
        if (pad !== 0) pad -= 1;
        indent = 0;
        break;
      case /^<\w([^>]*[^/])?>.*$/.test(node):
        indent = 1;
        break;
      default:
        indent = 0;
    }

    formatted += '  '.repeat(pad) + node + '\r\n';
    pad += indent;
  });
  return formatted.trim();
}